import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateEndpoints } from '@/modules/candidates/constants';
import { candidateJobNoteQueryKeys } from '@/modules/candidates/queries/queryKeys';
import type { ApiRequestBody } from '@/types/utils/request';
import { invalidateQuery } from '@/utils/queries';

type CreateCandidateJobNoteRequestBody = ApiRequestBody<
  typeof candidateEndpoints.candidateJobNotes,
  'post'
>;

type CreateCandidateJobNoteParams = {
  candidateJobId: string;
  body: CreateCandidateJobNoteRequestBody;
};

export const useCreateCandidateJobNoteMutation = () => {
  return useMutation({
    mutationFn: async ({
      candidateJobId,
      body,
    }: CreateCandidateJobNoteParams) => {
      const { data } = await fetchClient.POST(
        candidateEndpoints.candidateJobNotes,
        {
          params: { path: { candidateJobId } },
          body,
        },
      );

      return data;
    },
    onSettled: (_data, _error, { candidateJobId }) => {
      invalidateQuery(candidateJobNoteQueryKeys.list(candidateJobId))();
    },
  });
};
